const CaymanIslandsSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111107)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0048 20 0.0021875 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#0052B4"
      />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9818 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91563 20 4.60977 20 0H19.9966C8.95242 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3106 20H19.9466C19.9644 19.9822 19.9822 19.9644 20.0001 19.9465C20.0001 18.5991 20.0001 17.3968 20.0001 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M28.6956 14.7837C30.6166 14.7837 32.1738 13.2264 32.1738 11.3054C32.1738 9.38443 30.6166 7.82715 28.6956 7.82715C26.7746 7.82715 25.2173 9.38443 25.2173 11.3054C25.2173 13.2264 26.7746 14.7837 28.6956 14.7837Z"
        fill="#6DA544"
      />
      <path
        d="M10.1181 2.6084C6.99004 4.38957 4.38949 6.99004 2.6084 10.1181V19.9997H7.82582V7.82598V7.82582H19.9997C19.9997 6.18027 19.9997 4.61262 19.9997 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M19.9993 17.5403L12.8935 10.4346H10.4341V10.4347L19.9992 19.9997H19.9993C19.9993 19.9997 19.9993 18.3039 19.9993 17.5403Z"
        fill="#D80027"
      />
      <path d="M22.6084 10.4346H34.7823V15.652H22.6084V10.4346Z" fill="#D80027" />
      <path
        d="M22.6084 23.4785V26.9568H24.4384C25.5357 28.0321 27.0376 28.6959 28.6954 28.6959C30.3531 28.6959 31.855 28.0321 32.9523 26.9568H33.0432H34.7823V23.4785H22.6084Z"
        fill="#FFDA44"
      />
      <path
        d="M22.6084 14.7832V20.0006C22.6084 24.6599 28.6954 26.0876 28.6954 26.0876C28.6954 26.0876 34.7823 24.6599 34.7823 20.0006V14.7832H22.6084Z"
        fill="#338AF3"
      />
      <path
        d="M28.6959 17.5693C27.1743 17.5693 27.1743 18.9607 25.6527 18.9607C24.131 18.9607 24.131 17.5693 22.6094 17.5693V20.0041C24.131 20.0041 24.131 21.3954 25.6527 21.3954C27.1743 21.3954 27.1743 20.0041 28.6959 20.0041C30.2177 20.0041 30.2177 21.3954 31.7396 21.3954C33.2615 21.3954 33.2614 20.0041 34.7833 20.0041V17.5693C33.2615 17.5693 33.2615 18.9607 31.7396 18.9607C30.2177 18.9607 30.2177 17.5693 28.6959 17.5693Z"
        fill="#F3F3F3"
      />
      <path
        d="M28.6959 12.6953C27.1743 12.6953 27.1743 14.0866 25.6527 14.0866C24.131 14.0866 24.131 12.6953 22.6094 12.6953V15.1301C24.131 15.1301 24.131 16.5214 25.6527 16.5214C27.1743 16.5214 27.1743 15.1301 28.6959 15.1301C30.2177 15.1301 30.2177 16.5214 31.7396 16.5214C33.2615 16.5214 33.2614 15.1301 34.7833 15.1301V12.6953C33.2615 12.6953 33.2615 14.0866 31.7396 14.0866C30.2177 14.0866 30.2177 12.6953 28.6959 12.6953Z"
        fill="#F3F3F3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111107">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CaymanIslandsSvg;
